var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-content-pages section",attrs:{"id":"contentpage"}},[_c('div',{staticClass:"container"},[_c('BrandLogo'),_c('HomeButton'),(_vm.$route.params.id == 'impressum')?_c('Imprint'):_vm._e(),(_vm.$route.params.id == 'datenschutz')?_c('DataProtection'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }